export default "__VITE_ASSET__BNA5kXkl__"